import { useState } from "react";
import { Navigate } from "react-router-dom";

import AuthRoutes from "Routes/Components/Auth";
import NoAuthRoutes from "Routes/Components/NoAuth";

import { setPostLoginRedirect } from "Helpers/PostLoginRedirect";

import SegmentationProvider from "Contexts/Segmentation";

import UseAuth from "Hooks/UseAuth";

import HeadRight from "Components/Admin/Navigation/HeadRight";
import Sidebar from "Components/Admin/Navigation/Sidebar";
import PageWrapper from "Components/Admin/PageWrapper";

import * as S from "./styles";

const AdminLayout = ({ children, ...rest }) => {
  const { authorized, isAdmin } = UseAuth();
  const [open, setOpen] = useState(false);

  if (!authorized) {
    // Admin SEM TOKEN nenhum (o outro caso — token expirado — nem chega aqui:
    // `authorized` é só `!!localStorage.userJWTToken`, a tela monta e quem
    // expulsa é o 401 em Helpers/Error.js). Guarda o destino para o login
    // levá-lo de volta.
    setPostLoginRedirect(window.location.pathname + window.location.search);

    return <Navigate to={NoAuthRoutes.AdminLogin.path} replace />;
  }

  if (!isAdmin) {
    return <Navigate to={AuthRoutes.Dashboard.path} replace />;
  }

  return (
    <SegmentationProvider>
      <S.MainGrid open={open}>
        <HeadRight open={open} setOpen={setOpen} />
        <Sidebar open={open} setOpen={setOpen} />

        <S.MainContainer open={open}>
          {rest.noWrapper ? (
            { children }
          ) : (
            <PageWrapper
              breadcrumb={{ currentRoute: rest?.name, parent: rest?.parent }}
            >
              {children}
            </PageWrapper>
          )}
        </S.MainContainer>
      </S.MainGrid>
    </SegmentationProvider>
  );
};

export default AdminLayout;
